import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import _WidgetBase from 'dijit/_WidgetBase';
import RequestManager from 'more/RequestManager';
import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require('dojo/text!./SessionInfo.html'); // brauchma eigentlich ned ....
import PasswordChangeHome from '../../UI/PasswordChange/PasswordChangeHome';
import domConstruct from 'dojo/dom-construct';
import { DateHelpers, DiagnosticHelper, ToasterHelpers } from "../../../more/Helpers";
import { GoogleSyncSettings } from "../GoogleSyncTypes";
import GenericDialog from '../../UI/GenericDialog/GenericDialog';
import methodHooks from 'more/mdsMethodHooks';


interface cachedSubstitutionData {
    webuserID: string,
    substitutionCount: number
    substitutes: Array<any>
}
class SessionInfo extends methodHooks(compose(_WidgetBase)) {
    templateString: any = null;//template;

    sessionData: SessionData & TwoFactorProperties = null;

    private _availableSubstitutionCount: number;


    private _sessionId: string = "?";

    private _originalPagelinks: Array<Pagelink> = <Pagelink[]>window.pageLinks;

    protected _topics: Array<any>;

    protected _googleSyncSettings: GoogleSyncSettings = null;

    getCurrentEmployeeId(bGetActualUser?: boolean): string {
        if (this.sessionData != null) {
            if (bGetActualUser === true) {
                if (this.sessionData.ActualUserId) {
                    return this.sessionData.CurrentEmployeeId_Origin;
                }
            }
            return this.sessionData.CurrentEmployeeId;
        }

        return "";
    }

    getCurrentWebuserId(bGetActualUser?: boolean): string {
        if (this.sessionData != null) {
            if (bGetActualUser === true) {
                if (this.sessionData.ActualUserId) {
                    return this.sessionData.ActualUserId;
                }
            }
            return this.sessionData.UserId;
        }
        return "";
    }

    getUserName(bGetActualUser?: boolean): string {
        if (this.sessionData != null) {
            if (bGetActualUser === true) {
                if (this.sessionData.ActualUserId) {
                    return this.sessionData.ActualUserName;
                }
            }
            return this.sessionData.UserName;
        }
        return "";
    }

    getUserDisplayName(bGetActualUser?: boolean): string {
        if (this.sessionData != null) {
            if (bGetActualUser === true) {
                if (this.sessionData.ActualUserId) {
                    return this.sessionData.ActualUserDisplayName;
                }
            }
            return this.sessionData.UserDisplayName;
        }
        return "";
    }

    isSessionOpen(): boolean {
        if (this.sessionData != null) {
            return true;
        }
        return false;
    }

    getUserRoles(): Array<string> {
        //console.log("SessionInfo getUserRoles", this.sessionData);
        if (this.sessionData != null) {
            //console.log("SessionInfo getUserRoles result!", this.sessionData.Roles);
            return this.sessionData.Roles;
        }

        return new Array<string>();
    }

    getRoles(): Array<string> { // Alias
        return this.getUserRoles();
    }

    hasRole(roleName: string): boolean {
        let roles: Array<string> = this.getUserRoles();

        if (roles.indexOf(roleName) >= 0) {
            return true;
        }

        return false;
    }

    public getGoogleSyncSettings(): GoogleSyncSettings {
        return this._googleSyncSettings;
    }

    private _profilePicCallbacks: Array<Function>;
    private _profilePicRequest: any = null;
    hasFeature(module: string, feature?: string, caseSensitive?: boolean): boolean {
        return this._checkModule(module, feature, caseSensitive);
    }
    private _checkModule(module: string, feature?: string, caseSensitive?: boolean): boolean {
        let parts = module?.split("/");
        if (parts && parts.length && parts.length == 1) {
            parts = module?.split(".");
        }

        if (parts && parts.length >= 2) {
            module = parts[0];
            feature = parts[1];
        }

        if (!module || !feature) return false;

        if (caseSensitive != true) {
            feature = feature.toLowerCase();
            module = module.toLowerCase();
        }

        if (window.customerSettings?.modules) {
            for (let entry of window.customerSettings.modules) {
                let name = entry.name;
                if (caseSensitive != true) {
                    name = name.toLowerCase();
                }
                if (name == module) {
                    for (let entryFeature of entry.features) {
                        if (entryFeature && !caseSensitive) entryFeature = entryFeature.toLowerCase();
                        if (entryFeature == feature) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }
    }

    closeSession() {
        try {
            let bodyNode = document.body;

            bodyNode.classList.add("mds-fade")
            setTimeout(lang.hitch(bodyNode.classList, "add", "hidden"), 10);
        } catch (ex) {

        }

        topic.publish("/Session/Closing", null);

        let manager = new RequestManager();
        manager.post(window.appRoot + "session/close",
            {
                "sessionid": this._sessionId
            },
            lang.hitch(this, this._onCloseSessionResponse),
            lang.hitch(this, this._onCloseSessionError)
        );
    }

    private _onCloseSessionResponse(response) {
        topic.publish("/Session/Close", null);

        setTimeout(lang.hitch(this, function () {
            location.reload();
        }), 500);
    }

    private _onCloseSessionError(error: more.requestErrorMessage) {

        topic.publish("/Session/CheckForExistingSession", null);

        try {
            let bodyNode = document.body;

            bodyNode.classList.remove("hidden")

        } catch (ex) {

        }

        console.error(this.id + " _onCloseSessionError", error);
        alert(error.Message);

    }

    getProfilepicData(asyncCallback?: Function): ProfilePicData {

        //console.debug("getProfilepicData - already in session?", this.sessionData.profilePicData);

        let storage = localStorage.getItem("ego_profilePic");
        let storedCheckSum: number = -2;
        let storedWebuser: string = "xxx";
        let currentSessionChecksum: number = -1;
        let currentUserId = this.getCurrentWebuserId(true);
        let profilePicData: ProfilePicData = null;
        if (asyncCallback) {
            this._profilePicCallbacks.push(asyncCallback);
        }
        if (this.hasFeature("System/UserProfilePic")) {

            //if (this._profilePicRequest != null) {
            //    console.debug("getProfilepicData - not continuing because request is running", this._profilePicCallbacks.length);
            //    return null;
            //}

            if (storage) {
                try {
                    profilePicData = JSON.parse(storage);
                    storedCheckSum = profilePicData.checksum;
                    storedWebuser = profilePicData.webuserID;

                } catch (exception) {
                    console.warn("error parsing profile pic from local storage", exception);
                    storedCheckSum = -9;
                }
            }



            if (this.sessionData && this.sessionData.profilePicData) {
                currentSessionChecksum = this.sessionData.profilePicData.checksum;
            }

            // ist die Prüfsumme ok?
            if (currentSessionChecksum != storedCheckSum || currentUserId != storedWebuser) {
                // ist nicht ok, also nochmal laden und explizit nicht nur die checksum verlangen
                //console.debug("getProfilepicData - checksum not matching - reloading...", currentSessionChecksum, storedCheckSum);
                this._loadProfilePic(false);

                if (currentUserId != storedWebuser) {
                    // wenn im Storage das Bild eines anderen Users ist, dann jetzt raus
                    return;
                }

                // ansonsten inzwischen weitermachen und das alte Bild setzen bis das Laden fertig ist
            }
        }

        //console.info("getProfilepicData - calling callbacks", this._profilePicCallbacks.length, profilePicData);
        if (this.sessionData) {
            this.sessionData.profilePicData = profilePicData;


            let newCallbacks = [];
            for (let asyncCallback of this._profilePicCallbacks) {
                if (asyncCallback) {
                    try {
                        asyncCallback(profilePicData);
                    } catch (ex) {

                    }
                }
            }
        }

        if (this._profilePicRequest != null) {

        } else {
            //console.info("getProfilepicData - resetting callbacks, Request finished");
            //this._profilePicCallbacks = [];
        }


        return profilePicData;
    }

    private _loadProfilePic(checksumOnly: boolean): void {

        //console.debug("_loadProfilePic - only checksum?", checksumOnly);
        if (!this.hasFeature("System/UserProfilePic")) return;

        if (this._profilePicRequest != null) {
            //console.debug("_loadProfilePic - abort because request is running", this._profilePicCallbacks.length);

            return;
        }

        let userId = this.getCurrentWebuserId(true);

        let manager = new RequestManager();

        let data = { "webuserID": userId, "checksumOnly": checksumOnly === true };

        this._profilePicRequest = manager.post(
            window.appRoot + "Home/LoadWebuserProfilePic",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadProfilepicResponse, checksumOnly),
            lang.hitch(this, this._onLoadProfilepicError)
        );

    }

    private _onLoadProfilepicResponse(bIsChecksumOnly: boolean, response: ProfilePicData) {

        this._profilePicRequest = null;

        let currentDataTxt = localStorage.getItem("ego_profilePic");
        let currentData: ProfilePicData = { checksum: -8, base64: null, webuserID: "" };
        if (currentDataTxt) {
            try {
                currentData = JSON.parse(currentDataTxt);
            } catch (ex) {
                console.warn("could not parse storage data for profile pic", currentDataTxt);
            }
        }

        //console.debug("_onLoadProfilepicResponse - only checksum?", bIsChecksumOnly, response);

        // wenn nur geprüft worden ist ob das Bild noch dasselbe ist?
        if (bIsChecksumOnly) {
            if (currentData.checksum != response.checksum) {
                //console.debug("_onLoadProfilepicResponse - checksum does not match storage! reloading...", currentData.checksum, response.checksum);
                this._loadProfilePic(false);
                return;
            } else {
                //console.info("_onLoadProfilepicResponse - checksum matching storage", currentData, response);
                this.sessionData.profilePicData = currentData;
                this._profilePicCallbacks = [];
                return; // passt, nix mehr zu tun...
            }
        }

        else {
            //console.debug("_onLoadProfilepicResponse - reloaded picture, setting to storage", response);
            localStorage.setItem("ego_profilePic", JSON.stringify(response));
            currentData = response;
            this.sessionData.profilePicData = currentData;
        }

        this.getProfilepicData(); // nochmal aufrufen, dann werden die Callbacks abgearbeitet
    }

    private _onLoadProfilepicError(error: more.requestErrorMessage) {
        console.warn("_onLoadProfilepicError", error);

        this._profilePicRequest = null;
    }

    protected _onOpenSession(data?: any) {
        //console.log("SessionInfo - _onOpenSession", data);
        localStorage.removeItem("ego_profilePic");

        //this._rawData = data;
        this._updateFromRawData(data);
    }

    protected _onCheckSession(data?: any) {
        //console.log("SessionInfo - _onCheckSession", data);

        this._updateFromRawData(data);
    }

    protected _onCloseSession(data?: any) {
        //console.log("SessionInfo - _onCloseSession", data);
        localStorage.removeItem("ego_profilePic");

        //this._updateFromRawData(null);
        this._onCheckForExistingSessionResult(null);
    }

    protected _updateFromRawData(newData: any): void {

        //console.log("_updateFromRawData", newData);
        if (!newData) {
            this.sessionData = null;
            topic.publish("/Session/NewSession");

            if (!document.body.classList.contains("loggedOut")) {
                //document.body.classList.add("loggedOut");
                setTimeout(lang.hitch(document.body.classList, "add", "loggedOut"), 100);
            }
            return;
        }

        //console.debug("SessionInfo _updateFromRawData 2", this.sessionData);

        if (typeof (newData.result) != "undefined") {
            this.sessionData = newData.result;
        } else if (typeof (newData.sessionData) != "undefined") {
            this.sessionData = newData.sessionData;
        } else if (typeof (newData) == "string") {
            try {
                newData = JSON.parse(newData);
                this._updateFromRawData(newData);
                return;
            } catch (ex) {
                console.error(this.id + ": received invalid session data. probably errormessage: ", newData);
                topic.publish("/Session/InvalidSessionDataReceived", newData);
                return;
            }
        }
        else {
            this.sessionData = newData;
        }


        if (this.sessionData.Session.Id != this._sessionId) {

            this._sessionId = this.sessionData.Session.Id;
            topic.publish("/Session/NewSession");

            this.checkPasswordExpiration();

            // irgendwann in 5-15 Sekunden mal die Vertretungen checken:
            setTimeout(lang.hitch(this, this.checkSubstitutionAvailable), Math.random() * 10 * 1000 + 5000);

            // und ob die Session mal geupdatet gehört:
            setTimeout(lang.hitch(this, this._updateSessionIfOld), Math.random() * 10 * 1000 + 15000);

        }


        if (this.sessionData && this.sessionData.IsTwoFactorAuthMandatory && !this.sessionData.IsTwoFactorAuthEnabled) {

            if (location.pathname.toLowerCase().indexOf("/home/twofactorauthentication") == -1) {
                //location.href = window.appRoot + "home/TwoFactorAuthentication";
                let dlg = new GenericDialog();
                dlg.setup({
                    content: "TwoFactorAuthenticator__mandatory_message",
                    //buttonPreset: "close",
                    closeOnEnter: true,
                    closeOnEscape: true,
                    header: "TwoFactorAuthenticator__header",
                    size: "smaller",
                    additionalButtons: [{
                            internalName: "later",
                            callback: function () {

                            },
                        label: "TwoFactorAuthenticator__mandatory_information_laterButton",
                            bCloseOnClick: true,
                            position: "first"
                        }, {
                            internalName: "gotoSetup",
                            callback: function () {
                                location.href = window.appRoot + "home/TwoFactorAuthentication";
                            },
                            label: "TwoFactorAuthenticator__mandatory_information_setupButton",
                            bCloseOnClick: false,
                            styleClass: "primary",
                            position: "first",
                            iconClass: "fas fa-fingerprint"
                        }
                    ]
                });

            }
        }


        let isSubstitution = this.isSubstitutionActive();

        let bodyNode = document.body

        try {
            if (isSubstitution) {
                let userDisplay = this.getUserDisplayName();
                let userName = this.getUserName();

                bodyNode.classList.add("subsitutionActive");
                bodyNode.setAttribute("data-substitution-label", userDisplay);
                bodyNode.setAttribute("data-substitution-user", userName);

            } else {
                bodyNode.classList.remove("subsitutionActive");
                bodyNode.removeAttribute("data-substitution-label");
                bodyNode.removeAttribute("data-substitution-user");
            }
        } catch (ex) {

        }

        try {
            if (this.sessionData.Roles.indexOf("_DEV") != -1) {
                let btn = document.getElementById("customThemeSwitchBtn");
                if (btn) {
                //    btn.classList.remove("w3-hide");
                } 
            } else {
                window.localStorage.removeItem("_useBaseCSS");
            }
        } catch (ex) {

        }

        if (!isSubstitution) {

        }


        if (!!this.isSessionOpen()) {
            if (!document.body.classList.contains("loggedIn")) {
                document.body.classList.add("loggedIn");
            }
        } else {
            if (document.body.classList.contains("loggedIn")) {
                setTimeout( lang.hitch( document.body.classList, "remove", "loggedIn"), 2000);
            }

        }

        topic.publish("/Session/CurrentSessionData", this.sessionData);
    }

    isSubstitutionActive(): boolean {
        return this.getCurrentWebuserId() != this.getCurrentWebuserId(true);
    }

    checkForExistingSession(): void {

        var manager = new RequestManager();

        topic.publish("/Session/Loading", true);

        let waitingAnimationElement = document.getElementById("waitingForSession");
        if (waitingAnimationElement) waitingAnimationElement.classList.remove("w3-hide");

        let sessionID: string = null;
        sessionID = this.sessionData?.Session?.Id;

        manager.additionalErrorProperties = ["TwoFactorProblem", "TwoFactorPassthroughLogin"];

        manager.post(
            window.appRoot + "session/CheckForExistingSession",
            {
                "sessionid": sessionID
            },
            lang.hitch(this, this._onCheckForExistingSessionResult),
            lang.hitch(this, this._onCheckForExistingSessionError));
    }

    updateWebuserRoles() {
        let jsonData = "";


        let manager = new RequestManager();
        manager.silentExceptions = true;

        let url = window.appRoot + "Session/UpdateWebuserRoles";
        manager.post(
            url,
            {
                "jsonData": jsonData
            },
            lang.hitch(this, this._onUpdateWebuserroles as any),
            lang.hitch(this, this._onUpdateWebuserrolesError),
            false // sync
        );
    }

    private _onUpdateWebuserroles(result: SessionData | boolean) {
        console.info("userroles updated: ", result);
        ToasterHelpers.removeToast("/Session/UpdateUserroles");

        let anyresult = result as any;
        if (anyresult === false) return;
        if (typeof (anyresult) != "object" || anyresult == null) return;


        this._updateFromRawData(result);

        topic.publish("/Session/UserrolesUpdated", result);
    }

    private _onUpdateWebuserrolesError(error: more.requestErrorMessage) {
        if (this.hasRole("_DEV")) {
            ToasterHelpers.showToast({
                title: "Updating roles failed. Check errors!",
                message: error.Message,
                iconClass: toasterIcons.error,
                ID: "/Session/UpdateUserroles",
                showClose: true
            });
        }
        console.warn("userroles update failed: ", error);
    }

    private checkSubstitutionAvailable() {
        let jsonData = "";

        if (!this.hasFeature("system/enableUserSubstitution")) {

            this._updateAvailableSubstitutionsOnSession(null);

            return;
        }
        let manager = new RequestManager();
        manager.silentExceptions = true;

        manager.callfunction(
            "Webtool_GetSubstituteWebuserList",
            {
                "jsonData": jsonData
            },
            lang.hitch(this, this._onCheckSubstitutionAvailable),
            lang.hitch(this, this._onCheckSubstitutionError),
            false // sync
        );
    }

    private _onCheckSubstitutionAvailable(result: Array<any>) {
        if (!result?.length) {
            this._updateAvailableSubstitutionsOnSession(null);
        }

        else {
            this._updateAvailableSubstitutionsOnSession(result);
        }

        // irgendwann in den nächsten 5 - 15 Minuten wieder prüfen:
        // 5 Minuten ist Basis: 1000 * 60 * 5
        // 0-10 Minuten ist random:
        setTimeout(lang.hitch(this, this.checkSubstitutionAvailable), Math.random() * 10 * 1000 * 60 + 1000 * 60 * 5);

    }

    private _updateAvailableSubstitutionsOnSession(newEntities: Array<any>) {

        let newCount = 0;
        if (newEntities) newCount = newEntities.length;
        let currentData = this._getCachedSubstitutionData();
        if (currentData) {
            currentData.substitutionCount = newCount;
            currentData.substitutes = newEntities;
            this._setCachedSubstitutionData(currentData);
        }

        if (currentData && this.hasFeature("system/enableUserSubstitution")) {
            topic.publish("/Session/SubstutitionsAvailable", currentData?.substitutes);

        }
    }

    /**
     * Liefert für den aktuellen Webuser ein Array an möglichen vertretbaren Webusern, falls diese Info im Cache und das Feature im Webtool vorhanden ist.
     */
    getCachedSubstitutes(): Array<any> {
        let data = this._getCachedSubstitutionData();
        return data?.substitutes;
    }

    private _getCachedSubstitutionData(webuserId?: string): cachedSubstitutionData {
        if (!this.hasFeature("system/enableUserSubstitution")) {
            return null;
        }

        if (!webuserId) webuserId = this.getCurrentWebuserId(true);

        if (!this.isSessionOpen() || !webuserId) return null;

        if (this.isSubstitutionActive()) return null;

        let myCachedInfo: cachedSubstitutionData = null;

        let strData = localStorage.getItem("ego_userSubstitution");
        if (!strData) {

        } else {
            try {
                let cachedArray = JSON.parse(strData) as Array<cachedSubstitutionData>;

                for (let data of cachedArray) {
                    if (data.webuserID == webuserId) {
                        myCachedInfo = data;
                        break;
                    }
                }

            } catch (ex) {

            }
        }

        if (!myCachedInfo) {
            myCachedInfo = {
                webuserID: webuserId,
                substitutionCount: 0,
                substitutes: []
            };
        }

        return myCachedInfo;

    }

    private _setCachedSubstitutionData(data: cachedSubstitutionData) {
        if (!this.hasFeature("system/enableUserSubstitution")) {
            localStorage.removeItem("ego_userSubstitution");
            return;
        }

        if (!data) return;
        let webuserId = data.webuserID;

        if (!webuserId) return;

        let strData = localStorage.getItem("ego_userSubstitution");
        if (!strData) {
            strData = "[]";
        }
        try {
            let cachedArray = JSON.parse(strData) as Array<cachedSubstitutionData>;

            for (let i = 0; i < cachedArray.length; i++) {
                let data = cachedArray[i];
                if (data.webuserID == webuserId) {
                    cachedArray.splice(i, 1);
                    break;
                }
            }

            cachedArray.push(data);

            localStorage.setItem("ego_userSubstitution", JSON.stringify(cachedArray));

        } catch (ex) {

        }
    }

    getAvailableUserSubstitutionCount(): number {
        let data = this._getCachedSubstitutionData();
        if (data) return data.substitutionCount;

        return -1;
    }

    private _onCheckSubstitutionError(error: more.requestErrorMessage) {
        console.warn("checking available substitutions failed: ", error.Message);


        // irgendwann in den nächsten 5 - 15 Minuten wieder prüfen:
        // 5 Minuten ist Basis: 1000 * 60 * 5
        // 0-10 Minuten ist random:
        setTimeout(lang.hitch(this, this.checkSubstitutionAvailable), Math.random() * 10 * 1000 * 60 + 1000 * 60 * 5);
    }

    private _onCheckForExistingSessionResult(response: any): void {
        //console.log("SessionInfo CheckResult", response);
        if (response != null && response != "") {
            this._updateFromRawData(response);
            this._loadProfilePic(true);
            topic.publish("/Session/CheckForExistingSession", { result: response });
            topic.publish("/Session/SubstituteActive", this.isSubstitutionActive());
        }
        else {
            this._updateFromRawData(null);
            topic.publish("/Session/CheckForExistingSession", { result: null });
        }

        topic.publish("/Session/Loading", false);

        this._tryRemoveWaitingAnimation();

    }

    private _tryRemoveWaitingAnimation() {
        let waitingAnimationElement = document.getElementById("waitingForSession");
        if (waitingAnimationElement) {
            waitingAnimationElement.classList.add("w3-hide");
            setTimeout(domConstruct.destroy, 3000, waitingAnimationElement);
        }
    }

    private _onCheckForExistingSessionError(error: any) {

        console.error("_onCheckForExistingSessionError", error);
        topic.publish("/Session/Loading", false);

        if (error.TwoFactorProblem === true) {
            console.log("two factor auth needed");
        }

        this._tryRemoveWaitingAnimation();

    }

    private _updateSessionIfOld() {

        if (!this.sessionData?.Session?.LastUpdate) {
            return;
        }

        let sessionDate = new Date(parseInt(this.sessionData.Session.LastUpdate.substring(6)));
        let ageMinutes = DateHelpers.getDiffMinutes(sessionDate, new Date());

        if (ageMinutes > 12) {
            let requestManager = new RequestManager();
            requestManager.silentExceptions = true;


            this._profilePicRequest = requestManager.post(
                window.appRoot + "Session/Update",
                {
                    sessionId: this._sessionId
                },
                lang.hitch(this, this._onUpdateSessionResponse),
                lang.hitch(this, this._onUpdateSessionError)
            );
        } else {
            // ansonsten mal speziell Userrollen neu laden:
            this.updateWebuserRoles();
        }
    }

    private _onUpdateSessionResponse(response) {
        this._updateFromRawData(response);

        setTimeout(lang.hitch(this, this._updateSessionIfOld), 60 * 1000 * 10); // in 10 Minuten nochmal
    }

    private _onUpdateSessionError(error: more.requestErrorMessage) {

    }

    checkPasswordExpiration(callback?: Function) {
        let requestManager = new RequestManager();
        requestManager.silentExceptions = true;

        let data = {

        };

        this._profilePicRequest = requestManager.callfunction(
            "Webtool_API_Password__CheckExpiration",
            data,
            lang.hitch(this, this._onCheckExpirationResult, callback),
            lang.hitch(this, this._onCheckExpirationError)
        );
    }

    private _onCheckExpirationResult(callback: Function, result: { passwordExpired: boolean, webuserID: string }) {

        if (this.getCurrentWebuserId(true) == result?.webuserID && result?.passwordExpired == true) {
            try {
                let pw = new PasswordChangeHome();
                pw.isDialog = true;
                pw.placeAt(document.body);
                pw.startup();

                let translation = window.translations["ChangeUserPassword_PwdExpiredMessage"];
                if (!translation) console.warn("Translation for Password Expiration missing: ", "ChangeUserPassword_PwdExpiredMessage")

                pw.showStrict(translation);

            } catch (ex) {

            }
        }
    }

    private _onCheckExpirationError(error: more.requestErrorMessage) {
        console.warn("checking password expiration failed", error.Message);
    }

    protected _loadGoogleSyncSettings(): void {
        let manager = new RequestManager();
        manager.silentExceptions = true;

        manager.callfunction("Webtool_API_GoogleSync__GetSyncSettings", {}, lang.hitch(this, this._onLoadGoogleSyncSettingsResponse), lang.hitch(this, this._onLoadGoogleSyncSettingsError));
    }

    protected _onLoadGoogleSyncSettingsResponse(syncSettings: GoogleSyncSettings): void {

        //console.log("syncSettings", syncSettings);
        this._googleSyncSettings = syncSettings;
    }

    protected _onLoadGoogleSyncSettingsError(error): void {
        console.warn("error on loading google-sync-settings: ", error.Message);
    }

    protected _setupSubscriptions(): void {
        this._topics.push(topic.subscribe("/Session/UpdateUserroles", lang.hitch(this, this.updateWebuserRoles))); //
        this._topics.push(topic.subscribe("/Session/Open", lang.hitch(this, this._onOpenSession))); //
        //this._topics.push(topic.subscribe("/Session/CheckForExistingSession", lang.hitch(this, this._onCheckSession)));
        this._topics.push(topic.subscribe("/Session/Close", lang.hitch(this, this._onCloseSession)));
        this._topics.push(topic.subscribe("/LiveCommand/Session/Update", lang.hitch(this, this.updateWebuserRoles)));
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._topics = new Array<any>();

        this._setupSubscriptions();
        this._profilePicCallbacks = [];

        if (this.hasFeature("Session/AutomaticPolling")) {
            setInterval(lang.hitch(this, this.checkForExistingSession), 900000 * 2 - 60000); // 15 min x 2 - 1 Minute = 29 Minuten. Das Netscaler-Timeout ist auf 30 Minuten gesetzt. Läuft daher nie ab solange das Tab geöffnet ist
        }

        if (this.hasFeature("User/GoogleSyncManager")) {
            this._loadGoogleSyncSettings();
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (window.sessionInfo == null || typeof (window.sessionInfo) == "undefined") {
            window.sessionInfo = this;
            this.checkForExistingSession();
        } else if (window.sessionInfo == this) {
            this.checkForExistingSession();

        } else {
            this.destroy();
        }
    }
}

export default mdsWidget(SessionInfo);
